import React from "react";

const MapSection = () => {
	return (
		<>
			<div className="map-section-container">
				<div className="container map-section">
					<div className="map-container">
						<iframe
							title="Google Map"
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.54031651559!2d72.86840007509218!3d19.113002152017727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9538da64c97%3A0x45bc978da687e00f!2sMeera%20Jewellery%20House%20LLP!5e0!3m2!1sen!2sin!4v1730633390000!5m2!1sen!2sin"
							idth="100%"
							height="100%"
							style={{ border: 0 }}
							allowFullScreen=""
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade">
						</iframe>
					</div>
				</div>
			</div>
		</>
	);
};

export default MapSection;
